import type { Dictionary, Translation } from '@/i18n/types';

const ro = {
  title: 'Sesiunea a expirat',
  body: 'Modificările nu au fost salvate. Datele introduse sunt încă pe ecran — copiați-le dacă doriți să le păstrați, apoi autentificați-vă din nou.',
  reauthenticate: 'Autentificați-vă din nou',
  dismiss: 'Rămâneți pe pagină',
} as const;

const en = {
  title: 'Your session has expired',
  body: 'Your changes were not saved. What you typed is still on screen — copy it if you want to keep it, then sign in again.',
  reauthenticate: 'Sign in again',
  dismiss: 'Stay on this page',
} satisfies Translation<keyof typeof ro>;

export const sessionExpired = { ro, en } satisfies Dictionary;

export type SessionExpiredKey = keyof typeof ro;
